import {NgModule} from '@angular/core';
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {DQ_ENTITY_PROVIDER} from "./dq.entity-provider";
import {DQ_TEST_PROVIDERS} from "./test/dq-test-definition";
import {
    DqAuditFindingDashboardPage
} from "./page/dashboard/dq-audit-finding-dashboard/dq-audit-finding-dashboard.page";
import {DqConfigPage} from "./page/config/dq-config/dq-config.page";
import {
    DqAuditFindingDetailComponent
} from "./component/private-components/dq-audit-finding-detail/dq-audit-finding-detail.component";
import {
    DqAuditFindingReviewWorkbenchComponent
} from "./component/private-components/dq-audit-finding-review-workbench/dq-audit-finding-review-workbench.component";
import {
    DqAuditFindingObjectListComponent
} from "./component/private-components/dq-audit-finding-object-list/dq-audit-finding-object-list.component";
import {JbModule} from "../../feature-tech/jb/jb.module";

/**
 * dq (Data Quality) feature module.
 *
 * CoreModule re-exports SharedModule, which is where {@code mvs-review-workbench} and {@code mvs-widget}
 * are declared — importing CoreModule is therefore all the review workbench needs. No build or tooling
 * configuration change is involved.
 *
 * JbModule is imported for the generic, public {@code <jb-job-run-list>} rendered in the
 * „Job-Einplanung" section of the dashboard. jb does not import dq, so this creates no module cycle;
 * dm imports JbModule the same way from this very feature, and bd does from feature-bm.
 *
 * getKpiComponent()/getStatisticsComponent() return null for now, the same as {@code JbModule} and
 * {@code UfModule}: the module registers itself so the KPI container can resolve the alias 'dq', and a
 * later KPI/statistics component is a drop-in replacement for the two nulls.
 */
@NgModule({
    declarations: [
        DqAuditFindingDashboardPage,
        DqConfigPage,
        // Right pane of the review workbench — the finding under review. NOT exported: the
        // workbench is its only host, and a private component is dq-internal by definition
        // (fe_core_standards section 6).
        DqAuditFindingDetailComponent,
        // The review workbench itself — the splitter host that owns the worklist, the selection and
        // the queue. It moved out of the page when the dashboard became a hub, so that it can sit
        // behind navItem=workbench the way the three bd workbenches sit behind theirs. NOT exported:
        // the dq dashboard is its only host.
        DqAuditFindingReviewWorkbenchComponent,
        // „Betroffene Objekte“ of the finding under review — the main object and its Nebenobjekte as
        // compact rows that OPEN the object in the right side panel instead of embedding it. NOT
        // exported: the detail component is its only host.
        DqAuditFindingObjectListComponent,
    ],
    exports: [
        DqAuditFindingDashboardPage,
        DqConfigPage,
    ],
    imports: [
        CoreModule,
        UiModule,
        JbModule
    ],
    providers: [DQ_ENTITY_PROVIDER, DQ_TEST_PROVIDERS]
})
export class DqModule implements DynamicModule {

    alias = 'dq';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }
}
